module.exports = __webpack_public_path__ + "img/shoot_sorting.3356453.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/type-setting/shoot_sorting.svg
// module id = 9cTS
// module chunks = 1